import { availabilityService } from "./repository";

export default {
    async getPaymentManagementAvailability() {
        return availabilityService.get("invoicing"); // for local testing endpoint is https://localhost:5001/healthz
    }
};
